//import { useState, useEffect, useCallback, Fragment } from 'react';
import { FunctionComponent } from 'react';
import './buy-now-button.scss';
import A from '../html-tags/a';

export type Props = {
  order: 'buy' | 'test' | 'test14days' | 'buy->test' | 'test->buy' | 'shop' | 'compare';
};

const BuyNowButton: FunctionComponent<Props> = (props) => {
  //const history = useNavigate();

  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <>
      {props.order === 'buy' && (
        <A language="de" href="/de/prices" className="buy-now-button">
          Jetzt kaufen
        </A>
      )}
      {props.order === 'test' && (
        <A language="de" href="/de/freetrial" className="test-now-button">
          Jetzt testen
        </A>
      )}

      {props.order === 'test14days' && (
        <A language="de" href="/de/freetrial" className="test-now-button">
          Teste PS IMAGO PRO 14 Tage kostenlos
        </A>
      )}

      {props.order === 'buy->test' && (
        <>
          <A language="de" href="/de/prices" className="buy-now-button">
            Jetzt kaufen
          </A>
          <span style={{ marginLeft: '1rem' }}>oder erst </span>
          <A language="de" href="/de/freetrial" className="test-now-link">
            kostenlos testen
          </A>
        </>
      )}
      {props.order === 'test->buy' && (
        <>
          <A language="de" href="/de/freetrial" className="buy-now-button">
            Jetzt kostenlos testen
          </A>

          <div style={{ marginLeft: '1rem' }}>
            <span>
              oder gleich{' '}
              <A language="de" href="/de/prices" className="test-now-link">
                kaufen
              </A>
            </span>
          </div>
        </>
      )}
      {props.order === 'shop' && (
        <A language="de" href="/de/prices" className="shop-button">
          Zum Online Shop
        </A>
      )}
      {props.order === 'compare' && (
        <A language="de" href="/de/prices" className="compare-button">
          Preise Vergleichen
        </A>
      )}
    </>
  );
};

export default BuyNowButton;
